import { Component } from '@angular/core';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import { PropertyProviderModel } from 'app/models/property-provider.model';
import { NexusFormResultModel } from 'app/models/nexus-form-result.model';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormGroup } from '@angular/forms';
import { PropertyProviderCategoryModel } from 'app/models/property-provider-category.model';
import { PropertyProviderCategoryService } from 'app/services/property-provider-category.service';

@Component({
  standalone: false,
  selector: 'app-property-provider',
  templateUrl: './property-provider.component.html',
  styleUrls: ['./property-provider.component.scss']
})
export class PropertyProviderComponent extends NexusComponent {
  public property_provider_model: PropertyProviderModel = new PropertyProviderModel();
  public property_provider_category_model: PropertyProviderCategoryModel = new PropertyProviderCategoryModel();
  
  public form_result: NexusFormResultModel = new NexusFormResultModel();
  public form = new UntypedFormGroup({
    provider: this.CreateFormControl(),
    variance_threshold: this.CreateFormControl(),
    minimum_variance: this.CreateFormControl(),
    minimum_vacant_amount: this.CreateFormControl(),
    floorplan_variance_threshold: this.CreateFormControl(),
    floorplan_minimum_variance: this.CreateFormControl()
  });
  
  constructor(private route: ActivatedRoute, private router: Router, private service: PropertyProviderCategoryService) {
    super();
  }

  ngOnInit() {
    this.route.data.subscribe(({ property_provider_model, property_provider_category_model }) => {            
      if (property_provider_model)
      {
        this.property_provider_model = property_provider_model;
        this.form.patchValue(this.property_provider_model);
      }
      if (property_provider_category_model) {
        this.property_provider_category_model = property_provider_category_model;
        this.form.patchValue(this.property_provider_category_model);
      }
    });
    this.form.valueChanges.subscribe((form_data: any) => {
      this.PopulateModelFromForm(form_data, this.property_provider_category_model);
    });
  }

  submit() {
    this.form_result.Reset();

    this.SetFormTouched(this.form);
    if (this.form.invalid) {
      this.form_result.Incomplete();
      return;
    }

    this.StartSpinner();
    this.service.SaveProviderCategory(this.property_provider_category_model).subscribe(
      data => {
        this.property_provider_category_model = data;
        this.form_result.Success();
        this.StopSpinner();
        this.router.navigate(['/billing','providers']);
      },
      error => {
        this.form_result.Error(error);
        this.StopSpinner();
      });
  }

}
